import React from "react";

import classes from "./styles.module.scss";

const InThisRunPanel = ({
    numBaseFiles = 0,
    uniqueModels = 0,
    numUpgradePackages = 0,
    totalSimulations = 0,
}) => {
    const stats = [
        {
            id: "base-files",
            label: "Base model files",
            value: Number(numBaseFiles || 0).toLocaleString(),
        },
        {
            id: "orientations",
            label: "Unique orientations",
            value: Number(uniqueModels || 0).toLocaleString(),
        },
        {
            id: "packages",
            label: "Upgrade packages",
            value: Number(numUpgradePackages || 0).toLocaleString(),
        },
        {
            id: "total-sims",
            label: "Total simulations (full scope)",
            value: Number(totalSimulations || 0).toLocaleString(),
        },
    ];

    return (
        <section className={classes.panel} aria-labelledby="in-this-run-heading">
            <h3 className={classes.heading} id="in-this-run-heading">
                In this run
            </h3>
            <p className={classes.intro}>
                Community parametric runs simulate every ready base file across all upgrade packages and measure
                combinations configured for this community.
            </p>
            <dl className={classes.stats}>
                {stats.map(({ id, label, value }) => (
                    <div key={id} className={classes.statRow}>
                        <dt className={classes.statLabel}>{label}</dt>
                        <dd className={classes.statValue}>{value}</dd>
                    </div>
                ))}
            </dl>
        </section>
    );
};

export default InThisRunPanel;
